import { DeferredLoader } from "./deferred-loader";

export class ParcelTracking {
    public busy = ko.observable<boolean>(false);
    public errors = ko.observableArray<string>();
    public orderDate = ko.observable<string>();
    public orderNumber: KnockoutComputed<string>;
    public orderPrefix = ko.observable<string>();
    public orderPrefixText = ko.observable<string>('');
    public orderSuffix = ko.observable<string>();
    public postCode = ko.observable<string>();
    public siteId = ko.observable<string>("");

    public static Init(): ParcelTracking {
        let viewModel = new ParcelTracking();

        ko.applyBindings(viewModel);

        return viewModel;
    }

    constructor() {
        this.orderNumber = ko.pureComputed<string>(() => {
            return this.orderPrefix() + '-' + this.orderDate() + '-' + this.orderSuffix();
        });

        this.orderNumber = ko.pureComputed<string>({
            read: () => {
                return this.orderPrefix() + '-' + this.orderDate() + '-' + this.orderSuffix();
            },
            write: (value) => {
                this.orderDate('');
                this.orderPrefix('');
                this.orderSuffix('');

                if (!value) {
                    return;
                }

                let split = value.split('-');
                if (split.length !== 3) {
                    return;
                }
                this.orderDate(split[1]);
                this.orderPrefix(split[0]);
                this.orderSuffix(split[2]);
            },
            owner: this
        });

        this.setOrderNumberFromQuerystring();
        let siteId = (<HTMLInputElement>document.getElementById("SiteId")).value;
        this.siteId(siteId);
        this.orderPrefixText(`The order prefix should be OR${siteId} or OL${siteId}`);
    }

    public orderNumberLookup(): boolean {
        let form = <HTMLFormElement>document.getElementById("order-lookup-form");
        let formValid = window.validationService.isValid(form);

        if (formValid) {
            let json = ko.toJSON({ orderNumber: this.orderNumber(), postCode: this.postCode() });
            this.busy(true);
            window.HttpRequest.PostJson('/ws/lookup-tracking-reference', json,
                (data) => { this.onOrderDetailsReceived(data) },
                (data) => { this.postError(data) });
        }
        return false;
    }

    private onOrderDetailsReceived(json) {
        let data = JSON.parse(json);
        let errorsFound = this.displayErrors(data);
        this.busy(false);

        if (errorsFound === false && data.encryptedOrderNumber) {
            let form = document.getElementById("order-lookup-form");
            form.classList.add("hidden");
            this.loadParcelPerformWidget(data.encryptedOrderNumber);
        }
    }

    private postError(data) {
        this.displayErrors(data);
    }

    private displayErrors(data): boolean {
        this.errors.removeAll();

        if (data.errors?.length) {
            for (const element of data.errors) {
                this.errors.push(element.message);
            }
            return true; // Errors found.
        }

        return false; // No errors found.
    }

    private setOrderNumberFromQuerystring(): void {
        let orderNumber = window.UrlParser.GetParameterByName('orderNumber');

        if (orderNumber) {
            this.orderNumber(orderNumber);
        }

        let postcode = window.UrlParser.GetParameterByName('postcode');

        if (postcode) {
            this.postCode(postcode);
        }
    }

    private loadParcelPerformWidget(encryptedOrderNumber: string): void {
        let widgetDiv = document.getElementById("pp-widget-root");

        if (!widgetDiv) {
            return;
        }

        let trackProgress = document.getElementById("track-progress");
        trackProgress.classList.remove("hidden")

        // Rewrite the URL to be a direct link to the encrypted order number so the user can refresh or copy and paste it.
        let baseUrl = window.location.href.replace(location.search, "");
        const url = new URL(baseUrl);
        url.searchParams.set("pp_shipment_id", encryptedOrderNumber);
        window.history.pushState({}, "", url);

        widgetDiv.dataset.shipmentId = encryptedOrderNumber;
        DeferredLoader.InjectScript("https://tracking.parcelperform.com/pp-widget.js");
    }
}

if (document.body.dataset.pageInit == "tracking") {
    ParcelTracking.Init();
}
